import { io } from 'socket.io-client';
let socket;

export function initNotificationsSocket() {
  if (!socket) {
    socket = io('/', { path: '/socket.io', withCredentials: true, upgrade: false, auth: { token: "litnetoCRM5123588412" } }); // relative
    socket.on('connect', () => console.log('[socket] connected', socket.id));
    socket.on('connect_error', e => console.error('[socket] connect_error', e.message));
  }
  return socket;
}

export function getSocket() {
    return socket ?? initNotificationsSocket();
}